<template>
  <Modal
      v-model="_value"
      width="600"
      title="确认收款"
      @on-visible-change="visibleChange"
      ok-text="确认"
      @on-ok="onOk">

    <Form v-if="orderList.length > 0" ref="renewalOrderForm" :model="renewalOrder" :label-width="90">
      <div v-for="item in orderList">
        <FormItem prop="registrationNum" label="车牌号">
          <label style="display: inline-block; width: 100px;">{{item.positioningDeviceInfo.vehicleInfo != null ? item.positioningDeviceInfo.vehicleInfo.registrationNum : item.positioningDeviceInfo.vehicleInfo.vin}}</label>
          <label style="display: inline-block;">旧到费期：{{new Date(item.oldServiceDatetime).Format('yyyy年MM月dd日')}}</label>
          <br>
          <label style="display: inline-block; width: 100px;">金额：{{item.totalAmount}}</label>
          <label style="display: inline-block;">到费日期：{{new Date(item.serviceDatetime).Format('yyyy年MM月dd日')}}</label>
        </FormItem>
      </div>

      <div>
        <FormItem prop="state" label="收款结果">
          <Select style="width: 100px;" v-model="orderListstepstate">
            <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="result" label="不通过原因" v-if="orderListstepstate == 3">
          <Input style="display: inline-block; width: 400px;" type="textarea" v-model="orderListstepresult"
                 placeholder="不通过原因">
          </Input>
        </FormItem>
        <FormItem prop="serviceDatetime" label="服务到期日期" v-if="orderListstepstate == 2">
          <DatePicker type="date" style="width: 100%;" v-model="renewalOrder.serviceDatetime"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem prop="receptDatetime" label="收款日期" v-if="orderListstepstate == 2">
          <DatePicker type="date" style="width: 100%;" v-model="renewalOrder.receptDatetime"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
        <FormItem prop="totalAmount" label="单独订单金额" v-if="orderListstepstate == 2">
          <InputNumber :min="0" style="width: 100%;" v-model="renewalOrder.totalAmount"
                       placeholder="请输入总金额">
          </InputNumber>
        </FormItem>
        <FormItem prop="billType" label="开票类型" v-if="orderListstepstate == 2">
          <Select style="width: 100%;" v-model="renewalOrder.billType">
            <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </FormItem>
      </div>

    </Form>

    <Form v-else ref="renewalOrderForm" :model="renewalOrder" :label-width="90">
      <FormItem prop="registrationNum" label="车牌号">
        <label style="display: inline-block; width: 100px;">{{renewalOrder.positioningDeviceInfo.vehicleInfo != null ? renewalOrder.positioningDeviceInfo.vehicleInfo.registrationNum : renewalOrder.positioningDeviceInfo.vehicleInfo.vin}}</label>
      </FormItem>

      <div v-if="renewalOrder.step != null">
      <FormItem prop="state" label="收款结果" v-if="renewalOrder.step != null">
        <Select style="width: 100px;" v-model="renewalOrder.step.state">
          <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="result" label="不通过原因" v-if="renewalOrder.step != null && renewalOrder.step.state == 3">
        <Input style="display: inline-block; width: 400px;" type="textarea" v-model="renewalOrder.step.result"
               placeholder="不通过原因">
        </Input>
      </FormItem>
      <FormItem prop="serviceDatetime" label="服务到期日期" v-if="renewalOrder.step != null && renewalOrder.step.state == 2">
          <DatePicker type="date" style="width: 100%;" v-model="renewalOrder.serviceDatetime"
                      placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="receptDatetime" label="收款日期" v-if="renewalOrder.step != null && renewalOrder.step.state == 2">
          <DatePicker type="date" style="width: 100%;" v-model="renewalOrder.receptDatetime"
                      placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="totalAmount" label="总金额" v-if="renewalOrder.step != null && renewalOrder.step.state == 2">
          <InputNumber :min="0" style="width: 100%;" v-model="renewalOrder.totalAmount"
                       placeholder="请输入总金额">
          </InputNumber>
      </FormItem>
      <FormItem prop="billType" label="开票类型" v-if="renewalOrder.step != null && renewalOrder.step.state == 2">
          <Select style="width: 100%;" v-model="renewalOrder.billType">
            <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
      </FormItem>
      </div>

      <div v-else>
      <FormItem prop="serviceDatetime" label="服务到期日期">
        <DatePicker type="date" style="width: 100%;" v-model="renewalOrder.serviceDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="receptDatetime" label="收款日期">
        <DatePicker type="date" style="width: 100%;" v-model="renewalOrder.receptDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="totalAmount" label="总金额">
        <InputNumber :min="0" style="width: 100%;" v-model="renewalOrder.totalAmount"
                     placeholder="请输入总金额">
        </InputNumber>
      </FormItem>
      <FormItem prop="billType" label="开票类型">
        <Select style="width: 100%;" v-model="renewalOrder.billType">
          <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      </div>

    </Form>

  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'renewalorderconfirmreceptmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {
      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ],

      stepstateOptions: [
        { label: '通过', value: 2 },
        { label: '不通过', value: 3 }
      ],
      //  回访订单
      renewalOrder: {
        totalAmount: null,
        lastTotalAmount: null,
        oldServiceDatetime: null,
        serviceDatetime: null,
        businessUserId: null,
        businessUser: null,
        receptUserId: null,
        receptUser: null,
        positioningDeviceInfoId: null,
        positioningDeviceInfo: {
          terminalNum: null,
          factoryTerminalNum: null,
          positioningDeviceModel: {

          },
          vehicleInfo: {
            customName: null,
            registrationNum: null,
            registrationColor: null,
            vin: null,
            bodyColor: null,
            vehicleType: {
              id: null,
              name: null
            },
            vehicleBrand: {
              id: null,
              name: null
            },
            engineNum: null,
            vehicleLicenseNum: null,
            unladenMass: null,
            approvedLoad: null,
            vehicleOwnerInfoId: null,
            servicePassword: null,
            vehicleLicenseDistributeDatetime: null,
            vehicleLicenseReigsterDatetime: null,
            remark: null,
            certificateNum: null,
            certificateDistributeDatetime: null,
            vehicleModel: {
              id: null,
              name: null
            },
            chassisModel: null,
            chassisId: null,
            chassisCertificateNum: null,
            engineModel: null,
            energyType: null,
            displacement: null,
            power: null,
            energyUsage: null,
            emissionStandard: null,
            manufacturer: null,
            outlineSizeLong: null,
            outlineSizeWidth: null,
            outlineSizeHeight: null,
            boxSizeLong: null,
            boxSizeWidth: null,
            boxSizeHeight: null,
            springPieceCount: null,
            tyreCount: null,
            tyreSpec: null,
            wheelSpanFront: null,
            wheelSpanBack: null,
            wheelBase: null,
            axisLoad: null,
            axisCount: null,
            turnType: null,
            totalMass: null,
            approvedLoadCoefficient: null,
            towMax: null,
            saddleMax: null,
            cabPeopleCount: null,
            mannedCount: null,
            speedMax: null,
            productionDatetime: null,
            certificateRemark: null,
            vehicleLicensePictureId: null,
            certificatePictureId: null,
            vehicleSrcLicensePicture1Id: null,
            vehicleSrcLicensePicture2Id: null,
            vehicleBodyPictureId: null,
            vehicleUse: null,
            attention: false,
            mliftainsuranceChannelId: null,
            mliftainsurancechannelDatetime: null,
            tiinsuranceChannelId: null,
            tiinsurancechannelDatetime: null,
            insured: null
          }
        },
        updateDatetime: null,
        remark: null,
        billType: null,
        fileReady: null,
        salesChannelId: null,
        salesChannel: null,
        renewalOrderType: null,
        changeSim: null,
        maintainOrderId: null,
        maintainOrder: null,
        isfree: null,
        needJt808Combine: null,
        renewalNum: null,
        renewalPayOrderId: null,
        renewalPayOrder: null,
        deadlineDatetime: null,
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        }
      },

      orderList: [],
      orderIds: [],
      orderListstepstate: null,
      orderListstepresult: null

    }
  },
  methods: {
    ...mapActions([
      'RenewalOrderServ_ConfirmRecept'
    ]),
    onOk () {
      if (this.orderList != null && this.orderList.length > 0) {
        if (this.renewalOrder.serviceDatetime != null) {
          this.renewalOrder.serviceDatetime = new Date(this.renewalOrder.serviceDatetime).getTime()
        }
        store.dispatch('RenewalOrderServ_BatchConfirmRecept', {
          params:
              {
                orderList: this.orderIds,
                state: this.orderListstepstate,
                result: this.orderListstepresult,
                receptDatetime: new Date(this.renewalOrder.receptDatetime).Format('yyyy-MM-dd hh:mm:ss'),
                billType: this.renewalOrder.billType,
                serviceDatetime: this.renewalOrder.serviceDatetime,
                totalAmount: this.renewalOrder.totalAmount
              },
          urlparams: null
        }).then(() => {
          this.$Message.success('确认收款成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认服务期</p>',
          onOk: () => {
            store.dispatch('RenewalOrderServ_ConfirmRecept',
              { params: this.renewalOrder }).then(() => {
              this.$Message.success('确认成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.orderList = this._listValue
        this.orderIds = []
        if (this.orderList != null && this.orderList.length > 0) {
          this.orderList.forEach(item => {
            this.orderIds.push(item.id)
          })
          this.orderListstepstate = 2
          this.renewalOrder.receptDatetime = new Date()
        } else {
          this.orderIds = []

          this.renewalOrder.id = null
          this.renewalOrder.serviceDatetime = null
          this.renewalOrder.receptDatetime = null
          this.renewalOrder.billType = 1
          this.renewalOrder.totalAmount = 0
          this.renewalOrder.remark = null

          let renewalOrderId = this._initValue
          if (renewalOrderId) {
            store.dispatch('RenewalOrderServ_GetDetail', {
              params: { id: renewalOrderId }
            }).then(() => {
              this.renewalOrder = store.getters.get_RenewalOrder_GetDetailResult
              this.renewalOrder.serviceDatetime = new Date(this.renewalOrder.serviceDatetime)
              this.renewalOrder.receptDatetime = new Date()
              if (this.renewalOrder.step) {
                this.renewalOrder.step.state = 2
              }
              this.renewalOrder.remark = null
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
